import { Audience } from '../../../../../Types/generated-types'

interface EventTypeAttributes {
  guestHeadingPrefix: string
  guestLabel: string
  defaultAudience?: Audience
  forceAudience?: Audience //  when attributes are 'forced' the corresponding input won't be shown
  forceLayout?: string
}

const ATTRIBUTES_BY_EVENT_TYPE: Record<string, EventTypeAttributes | undefined> = {
  Party: { guestHeadingPrefix: 'Woohoo! 🕺💃', guestLabel: 'party people' },
  'Private Dining': {
    guestHeadingPrefix: 'Delicious! 🍽',
    guestLabel: 'diners',
    forceLayout: 'seating',
  },
  'Meeting/Workshop': {
    guestHeadingPrefix: 'Splendid! 💼',
    guestLabel: 'attendees',
    forceLayout: 'seating',
    defaultAudience: Audience['Professional'],
  },
  'Team Activity': {
    guestHeadingPrefix: 'Sounds like fun! 🎉',
    guestLabel: 'participants',
    defaultAudience: Audience['Professional'],
  },
  Presentation: {
    guestHeadingPrefix: 'Exciting! 🎤',
    guestLabel: 'attendees',
    defaultAudience: Audience['Professional'],
  },
  Wedding: {
    guestHeadingPrefix: 'Congratulations! 💐',
    guestLabel: 'guests',
    forceAudience: Audience['Personal'],
  },
  Networking: {
    guestHeadingPrefix: 'Terrific! 🤝',
    guestLabel: 'guests',
    defaultAudience: Audience['Professional'],
  },
  Studio: { guestHeadingPrefix: 'Awesome! 📸 🎧', guestLabel: 'superstars' },
  Conference: {
    guestHeadingPrefix: 'Excellent! 🎤',
    guestLabel: 'attendees',
    defaultAudience: Audience['Professional'],
  },
  'Something Else': { guestHeadingPrefix: 'Marvelous! ✨', guestLabel: 'guests' },
}

export default ATTRIBUTES_BY_EVENT_TYPE
